/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import apiClient from './apiClient';
import type { User, Role } from '../store/slices/authSlice';
import type { appConfigs, LoginAppRights } from '../components/types/types';

export interface AuthResponse {
  user: User;
  tableauToken?: string;
  token: string;
  role: Role[];
  appConfigs: appConfigs;
  appRights: LoginAppRights[];
  isValidPwd?: boolean;
  messages?: string;
}

/**
 * Authorizes a user using the productAuthToken from the URL.
 * Matches the required handshake format: GET request with Bearer token.
 * @param productAuthToken Token for product authentication
 * @returns The authorization response
 */
export const engageAuthorization = async (productAuthToken: string): Promise<AuthResponse> => {
  const response = await apiClient.get<AuthResponse>(
    `/engage/authorization`,
    {
      headers: {
        'accept': '*/*',
        'Authorization': `Bearer ${productAuthToken}`,
        'Content-Type': 'application/json',
      },
    }
  );

  return response.data;
};
